import { api } from '../../client';

export interface CustomerDto {
  id: string;
  company_name: string;
  display_name: string;
  email: string;
  phone: string;
  tax_id: string;
  street_address: string;
  city: string;
  state_province: string;
  postal_code: string;
  country: string;
  payment_terms: string;
  credit_limit: number | null;
  outstanding: number;
  total_revenue: number;
  status: string;
  created_at?: string;
  updated_at?: string;
}

export const salesCustomersApi = {
  async list(
    search?: string
  ): Promise<{ data?: CustomerDto[]; message?: string; errors?: Record<string, string[]> }> {
    const q = search ? `?search=${encodeURIComponent(search)}` : '';
    return api.get(`/sales/customers${q}`) as Promise<{ data: CustomerDto[] }>;
  },

  async get(id: string): Promise<{ data?: CustomerDto; message?: string }> {
    return api.get(`/sales/customers/${id}`) as Promise<{ data: CustomerDto }>;
  },

  async create(data: {
    company_name: string;
    display_name?: string;
    email?: string;
    phone?: string;
    tax_id?: string;
    street_address?: string;
    city?: string;
    state_province?: string;
    postal_code?: string;
    country?: string;
    payment_terms?: string;
    credit_limit?: number | null;
    status?: string;
  }): Promise<{ data?: CustomerDto; message?: string; errors?: Record<string, string[]> }> {
    return api.post('/sales/customers', data) as Promise<{
      data: CustomerDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async update(
    id: string,
    data: {
      company_name?: string;
      display_name?: string;
      email?: string;
      phone?: string;
      tax_id?: string;
      street_address?: string;
      city?: string;
      state_province?: string;
      postal_code?: string;
      country?: string;
      payment_terms?: string;
      credit_limit?: number | null;
      status?: string;
    }
  ): Promise<{ data?: CustomerDto; message?: string; errors?: Record<string, string[]> }> {
    return api.put(`/sales/customers/${id}`, data) as Promise<{
      data: CustomerDto;
      message?: string;
      errors?: Record<string, string[]>;
    }>;
  },

  async delete(id: string): Promise<{ success?: boolean; message?: string }> {
    return api.delete(`/sales/customers/${id}`) as Promise<{ success?: boolean; message?: string }>;
  },
};
